import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';

import {awsConfig} from '../../shared/config';
import {setBucket, addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import { CourseRegistrationStatus } from '../../components/constants/Consts';
import * as RestCallHelper from '../../utils/network/RestCallHelper'

const coursesLoading = (loadCriteria) => ({
    type: ActionTypes.EMPLOYEE_COURSES_LOADING,
    payload: loadCriteria
});

const addEmployeeCourses = (courses) => ({
    type: ActionTypes.ADD_EMPLOYEE_COURSES,
    payload: courses
});


const addCourse = (course) => ({
    type: ActionTypes.ADD_EMPLOYEE_COURSE,
    payload: course
});

const coursesFailed = (errmess) => ({
    type: ActionTypes.EMPLOYEE_COURSES_FAILED,
    payload: errmess
});

const updateCourse = (course) => (
    (course.details.courseStatus === CourseRegistrationStatus.Completed) ?
        {
            type: ActionTypes.DELETE_EMPLOYEE_COURSE,
            payload: course
        }
        :
        {
            type: ActionTypes.UPDATE_EMPLOYEE_COURSE,
            payload: course
        }
);

export const fetchCourses = (employeeId) => (dispatch) => {
    dispatch(coursesLoading({employeeId: employeeId}));

    const urlParams = new URLSearchParams({ employeeId: employeeId });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES_COURSES}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(courses => dispatch(addEmployeeCourses(courses)))
        .catch(error => {
            dispatch(coursesFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Cursurilor" } }));
        });
}
  
export const postEmployeeCourse = (course) => (dispatch) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYEES_COURSES, {
        method: "POST",
        body: JSON.stringify(course),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(course => dispatch(addCourse(course)))
        .then(courseAction => dispatch(setBucket({ mostRecentEeCourseId: courseAction.payload.id, snackbar: { open: true, severity: "success", message: "Cursul a fost creat cu succes" } })))
        .catch(error => {
            dispatch(coursesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Cursului" } }));
        });
}


export const patchEmployeeCourse = (course) => (dispatch) => {
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYEES_COURSES + `/${course.id}`, {
        method: "PATCH",
        body: JSON.stringify(course),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(course => dispatch(updateCourse(course)))
        .then(courseAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Date Curs actualizate cu succes" } })))
        .catch(error => {
            dispatch(coursesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii datelor Curs" } }));
        });
}


export const postEmployeeCourseCert = (fileName, certBase64, employerId, employeeId, courseId) => (dispatch) => {

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYEES_COURSES_CERT}`);

    const bodyContent = {
        fileName: fileName,
        certBase64: certBase64,
        employerId: employerId,
        employeeId: employeeId,
        courseId: courseId
    };

    return RestCallHelper.postAsJson(url, bodyContent)
        .then(course => dispatch(updateCourse(course)))
        .then(courseAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Certificat curs salvat cu succes" } })))
        .catch(error => {
            dispatch(coursesFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul salvarii certificatului" } }));
        });
}
